export default __webpack_public_path__ + "static/media/Clarified Bloodroyal Brandy.b8a03e70.jpg";